/**
 * Eventos del módulo de propuestas.
 *
 * Viven en su propio archivo y no junto al componente porque exportar una
 * constante desde un archivo de componentes rompe la recarga en caliente de
 * React: al tocar el componente, Vite ya no puede reemplazarlo en el aire y
 * recarga la página entera.
 */

/** Abre el modal de "Sugerir mejora". Lo emite el speed dial y el board. */
export const EVENTO_SUGERIR_MEJORA = 'sf:sugerir-mejora';
